/**
 * Given that enum definitions are shown alongside enum literals that may be defined in higher layers,
 * definitions need to be retrieved from the current layer or layers below if the definition is not found in the current layer.
 * This hook provides a memoized map of enum definitions for the current layer and layers below.
 */

import { useMemo } from 'react'

import { useMetaModelContext } from '../context/metaModelContext'
import { useNavigationParams } from '../system/useNavigationParams'
import { getApplicationViewConfiguredEnums } from './helpers'
import { useOperationsContext } from './operationsContext'

export const useApplicationViewEnumDefinitions = () => {
  const { configuredEnums } = useOperationsContext()
  const { block, layer } = useNavigationParams()
  const { layerTopology, blockTopology } = useMetaModelContext()
  return useMemo(
    () =>
      getApplicationViewConfiguredEnums({
        configuredEnums,
        block,
        layer,
        layerTopology,
        blockTopology,
      }),
    [configuredEnums, layer, layerTopology, block, blockTopology],
  )
}
